import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [女用户 2 分钟回复活动 首页接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=155160094
export const homepage = createAsyncThunk(
  'Saada/live/hiya_socialize/act_quick_reply_homepage',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/act_quick_reply_homepage',
      {
        ...p,
      },
      {
        store,
      }
    )
    return resp.data
  }
)

// 定义 ActDailyData 接口，表示每日活动数据
interface ActDailyData {
  session_count: number // 收到会话数
  reply_count: number // 回复数
  reply_rate: string // 回复率，例如 "5%"
  pearl: number // 珍珠数
}

// 定义 RankItem 接口，表示排行条目
interface RankItem {
  rank: number // 排名
  name: string // 昵称
  avatar: string // 头像
  reply_count: number // 回复数
}

interface RewardItem {
  session_count: number // 会话数
  reply_rate: string //	回复率
  pearl: number // 珍珠数
}
// 定义 API 返回数据的接口
interface InitialStateType {
  err_msg: string // 错误信息
  show: boolean // 是否显示活动
  today_data: ActDailyData // 今日数据
  yesterday_data: ActDailyData // 昨天数据
  rank_list: RankItem[] // 排行榜列表
  my_rank: RankItem // 我的排行
  list: RewardItem[]
  start_time: string
  end_time: string
  content: string
}

const initialState: Partial<InitialStateType> = {}

export const ReplyTwoSlice = createSlice({
  name: 'ReplyTwo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload.data)
    })
  },
})

export default ReplyTwoSlice.reducer

export const useReplyTwoState = () => {
  const data = useSelector((state) => {
    return state.ReplyTwo
  })
  return data
}
